export default {
  jurisdiction_building_stocks: [],
  custom_building_stocks: [],
  is_updating : false,
}